import type { DashboardMetricDensityColumns } from '@/components/dashboard/resolve-metric-grid-columns'
import { resolveDensityGridColumns } from '@/components/dashboard/resolve-metric-grid-columns'
import { cn } from '@/lib/utils'

export type DashboardMetricMaxColumns = 2 | 3 | 4 | 5
export type DashboardMetricColumnLayout = 'responsive' | 'density'

const DENSITY_GRID_CLASSES: Record<DashboardMetricDensityColumns, string> = {
  1: 'grid grid-cols-1 gap-4',
  2: 'grid grid-cols-1 @2col:grid-cols-2 gap-4',
  3: 'grid grid-cols-1 @2col:grid-cols-2 @3col:grid-cols-3 gap-4',
  4: 'grid grid-cols-1 @2col:grid-cols-2 @3col:grid-cols-4 gap-4',
}

const METRIC_GRID_CLASSES: Record<DashboardMetricMaxColumns, string> = {
  2: 'grid grid-cols-1 @2col:grid-cols-2 gap-4',
  3: 'grid grid-cols-1 @2col:grid-cols-2 @3col:grid-cols-3 gap-4',
  4: 'grid grid-cols-1 @2col:grid-cols-2 @3col:grid-cols-3 @4col:grid-cols-4 gap-4',
  5: 'grid grid-cols-1 @2col:grid-cols-2 @3col:grid-cols-3 @4col:grid-cols-4 @5col:grid-cols-5 gap-4',
}

/** Candidate home: five unboxed KPIs squeeze 5 → 4 → 3 → 2 via @kpi3 / @kpi4. */
export const CANDIDATE_KPI_GRID =
  'grid grid-cols-1 @2col:grid-cols-2 @kpi3:grid-cols-3 @kpi4:grid-cols-4 @3col:grid-cols-5 gap-x-3 gap-y-4'

export function dashboardMetricGridClassName(
  maxColumns: DashboardMetricMaxColumns = 5,
  className?: string,
) {
  return cn(METRIC_GRID_CLASSES[maxColumns], className)
}

export function dashboardMetricGridDensityClassName(
  columns: DashboardMetricDensityColumns,
  className?: string,
) {
  return cn(DENSITY_GRID_CLASSES[columns], className)
}

/** When `layoutClassName` is set, other layout props are ignored. */
export function resolveDashboardMetricGridClassName({
  layoutClassName,
  columnLayout = 'responsive',
  itemCount,
  maxColumns = 5,
}: {
  layoutClassName?: string
  columnLayout?: DashboardMetricColumnLayout
  itemCount: number
  maxColumns?: DashboardMetricMaxColumns
}): string {
  if (layoutClassName) return layoutClassName

  return columnLayout === 'density'
    ? dashboardMetricGridDensityClassName(
        resolveDensityGridColumns(itemCount, maxColumns),
      )
    : dashboardMetricGridClassName(maxColumns)
}

/** @deprecated Prefer `maxColumns` — maps legacy `columns` prop to grid width. */
export function legacyColumnsToMaxColumns(columns: 2 | 4): DashboardMetricMaxColumns {
  return columns === 2 ? 2 : 4
}
